/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import "./styles/Homework.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { getImageURL } from "../../utils/url";
import { TaskCards } from "../TaskList/components/TaskCards";

const fixThumbnailUrl = (url) => {
  if (!url) {
    return process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";
  }

  if (url.startsWith("https://")) {
    return url;
  } else {
    return "https://xcell-cms-files.s3.amazonaws.com/" + url;
  }
};

const HomeworkStyle = {
  backgroundImage: `url(${
    process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png"
  })`,
  backgroundSize: "cover",
  minHeight: "245px",
  height: "100%",
  borderBottomRightRadius: "17px",
  borderBottomLeftRadius: "17px",
};

const Homework = ({ selectedClass, selectedSubject }) => {
  const [homeworkTasks, setHomeworkTasks] = useState([]);
  const [homeworkTaskLoader, setHomeworkTaskLoader] = useState(true);

  useEffect(() => {
    const fetchHomeworkTask = async () => {
      const authToken = localStorage.getItem("authToken");
      const date = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      ).toISOString();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN}/api/v1/tasks?public=true&taskType=homework&section=${selectedClass}&subject=${selectedSubject}`,
          {
            headers: {
              token: authToken,
            },
          },
        );
        console.log("homeworkk task data->", response);
        if (response.data.status === "success") {
          setHomeworkTasks(response.data.data.tasks);
        }
      } catch (error) {
        console.log(error);
      }

      setHomeworkTaskLoader(false);
    };

    fetchHomeworkTask();
  }, [selectedClass, selectedSubject]);

  return (
    <TaskCards
      tasks={homeworkTasks}
      setTasks={setHomeworkTasks}
      loading={homeworkTaskLoader}
      message={"No homework assigned"}
    />
  );
};

export default Homework;
